import type {
  RadioChangeFn,
  RadioGroupProps,
} from '../../../components/RadioGroup/RadioGroup';

import RadioGroup from '../../../components/RadioGroup/RadioGroup';

import useYjsField from '../../collaboration/useYjsField';
import { useFieldContext } from '../../form';
import { useFieldErrors } from '../../useFieldErrors';

const RadioField = ({
  onFocus,
  onBlur,
  disabled,
  ...props
}: RadioGroupProps) => {
  const field = useFieldContext<string | number>();
  const errors = useFieldErrors(field.name);
  const yjsField = useYjsField('string');

  const onChange: RadioChangeFn = (e) => {
    const value = e.target.value;
    field.handleChange(value);
    yjsField.update(value);
  };

  const onFieldFocus = (e: { target: { name: string } }) => {
    onFocus?.(e);
    yjsField.onFocus();
  };

  const onFieldBlur = (e: { target: { name: string } }) => {
    onBlur?.(e);
    field.handleBlur();
    yjsField.onBlur();
  };

  return (
    <RadioGroup
      {...props}
      name={field.name}
      value={field.state.value}
      onChange={onChange}
      error={errors}
      onFocus={onFieldFocus}
      onBlur={onFieldBlur}
      disabled={disabled || yjsField.isBeingEdited}
      editors={yjsField.fieldEditors}
    />
  );
};

export default RadioField;
